import { useMemo } from 'react';
import {
  FieldType,
  MultiSelectField,
  SourceType,
} from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { useProjectTemplates } from 'queries';
import { getRandomColor } from 'utils/get-random-color';

export const useTemplateField = (
  fieldId: number,
): {
  templateField: MultiSelectField;
  isLoading: boolean;
} => {
  const { data: templates, isLoading } = useProjectTemplates();
  const fieldLabel = useTranslation('project.fields.template');

  return useMemo(
    () => ({
      templateField: {
        type: FieldType.MultiSelect,
        customField: false,
        fieldId,
        fieldName: 'template',
        fieldLabel,
        metaData: {
          options: (templates ?? []).map((x) => ({
            label: x.templateName ?? '',
            value: x.templateId as number,
            color: getRandomColor(x.templateId as number),
            active: true,
          })),
        },
        private: true,
        sourceType: SourceType.Project,
      },
      isLoading,
    }),
    [fieldId, fieldLabel, isLoading, templates],
  );
};
